import { makeStyles } from "../../providers/makeStyles";
import { scoreParser } from "../../forms/parsers/scoreParser";
import { SelfSubmittingField } from "../../layout/forms/selfSubmittingField/SelfSubmittingField";
import { forwardRef } from "react";

const useStyles = makeStyles(theme => ({
    form: {
        height: "100%",
        "div": {
            height: "100%",
        },
        "div > div": {
            width: "100%",
            maxWidth: 70,
            borderRadius: 0,
            borderWidth: 2,
            borderColor: "transparent",
            "&:hover": {
                borderColor: "transparent",
            },
            "&.error:focus-within, &.error:hover": {
                borderColor: theme.palette.input.error,
            }
        },
        input: {
            width: "100%",
            height: "100%",
            padding: 0,
            textAlign: "center"
        }
    },
}));
type ScoreFormProps = {
    onSubmit: (values: any) => Promise<any>;
    score?: number;
    judgingScale?: number;
    judgingDecimals?: number;
    postSubmit?: () => void;
};

export const ScoreForm = forwardRef<HTMLDivElement, ScoreFormProps>(({
    score,
    judgingScale,
    judgingDecimals,
    onSubmit,
    postSubmit,
}, ref) => {
    const classes = useStyles();

    const field = {
        name: "score",
        type: "number",
        inputProps: { pattern: "[0-9]*", step: "any", autoFocus: true, autoComplete: "off" },
        parse: scoreParser(judgingScale, judgingDecimals)
    };

    return (
        <div className={classes.form} ref={ref}>
            <SelfSubmittingField
                onSubmit={onSubmit}
                initialValue={score != null ? score.toString() : ""}
                field={field}
                postSubmit={e => e.type !== "change" && postSubmit?.()}
                onEvent={(e: React.BaseSyntheticEvent) => e.type === "submit" && (document.activeElement instanceof HTMLElement) && document.activeElement.blur()}
            />
        </div>
    );
});
